import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X, Instagram } from 'lucide-react';

// Easy logo replacement - Updated LOVEYUHLIFE logo
const LOGO_URL = "https://customer-assets.emergentagent.com/job_loveyuh-dev/artifacts/jliskk6c_Untitled%20design.png";

const Header = ({ onGetInTouchClick }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavClick = (href) => {
    // Close mobile menu when nav item is clicked
    setIsMobileMenuOpen(false);
    
    // Smooth scroll to section
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleGetInTouchClick = () => {
    setIsMobileMenuOpen(false);
    onGetInTouchClick();
  };

  const handleLogoClick = () => {
    // Close mobile menu if open
    setIsMobileMenuOpen(false);
    
    // Scroll to top of page smoothly
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-opacity-95 backdrop-blur-sm border-b border-opacity-10" style={{ backgroundColor: 'var(--bg-page)', borderColor: 'var(--border-light)', minHeight: '120px' }}>
      <div className="container">
        <nav className="flex items-center justify-between py-4 md:py-6" style={{ minHeight: '110px' }}>
          {/* Logo */}
          <div className="flex items-center">
            <button 
              onClick={handleLogoClick}
              className="focus:outline-none focus:ring-2 focus:ring-opacity-50 rounded-lg transition-transform hover:scale-105"
              style={{ focusRingColor: 'var(--brand-primary)' }}
              aria-label="Go to homepage top"
            >
              <img 
                src={LOGO_URL}
                alt="LOVEYUHLIFE - Professional Web Development and Digital Solutions for Small Business in Toronto, Canada" 
                className="h-40 md:h-48 w-auto rounded-lg shadow-sm cursor-pointer"
                style={{ 
                  background: '#ffffff',
                  padding: '8px'
                }}
                width="300"
                height="200"
                loading="eager"
              />
            </button>
          </div>
          
          {/* Desktop Navigation Links */}
          <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
            <button onClick={() => handleNavClick('#services')} className="nav-link">Services</button>
            <button onClick={() => handleNavClick('#testimonials')} className="nav-link">Reviews</button>
            <button onClick={() => handleNavClick('#contact')} className="nav-link">Contact</button>
            
            {/* Instagram Icon */}
            <a 
              href="https://www.instagram.com/loveyuhlife" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-2xl transition-colors hover:scale-110 transform transition-transform duration-200"
              style={{ color: 'var(--brand-primary)' }}
              aria-label="Follow us on Instagram"
            >
              <Instagram size={24} />
            </a>
          </div>
          
          {/* Desktop CTA Button */}
          <Button 
            onClick={onGetInTouchClick}
            className="hidden md:flex btn-primary btn-hover-scale"
          >
            Get In Touch
          </Button>

          {/* Mobile Menu Button */}
          <Button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 rounded-lg"
            variant="ghost"
            size="sm"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </Button>
        </nav>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 border-t" style={{ backgroundColor: 'var(--bg-page)', borderColor: 'var(--border-light)' }}>
            <div className="container py-4 space-y-2">
              <button 
                onClick={() => handleNavClick('#services')} 
                className="block w-full text-left mobile-nav-item transition-colors hover:bg-opacity-10"
                style={{ color: 'var(--text-primary)', backgroundColor: 'transparent' }}
              >
                Services
              </button>
              <button 
                onClick={() => handleNavClick('#testimonials')} 
                className="block w-full text-left mobile-nav-item transition-colors hover:bg-opacity-10"
                style={{ color: 'var(--text-primary)', backgroundColor: 'transparent' }}
              >
                Reviews
              </button>
              <button 
                onClick={() => handleNavClick('#contact')} 
                className="block w-full text-left mobile-nav-item transition-colors hover:bg-opacity-10"
                style={{ color: 'var(--text-primary)', backgroundColor: 'transparent' }}
              >
                Contact
              </button>
              
              {/* Mobile Instagram Link */}
              <div className="py-2">
                <a 
                  href="https://www.instagram.com/loveyuhlife" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 mobile-nav-item transition-colors hover:bg-opacity-10"
                  style={{ color: 'var(--brand-primary)', backgroundColor: 'transparent' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <Instagram size={20} />
                  Follow us on Instagram
                </a>
              </div>
              
              <div className="pt-4 border-t" style={{ borderColor: 'var(--border-light)' }}>
                <Button 
                  onClick={handleGetInTouchClick}
                  className="btn-primary btn-hover-scale w-full"
                >
                  Get In Touch
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;